export default "__VITE_ASSET__DCOXCGhQ__"